'use client'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { usePathname, useRouter } from 'next/navigation'
import React from 'react'

type LayoutProps = {
  children: React.ReactNode
  title: React.ReactNode
  info?: React.ReactNode
  actions?: React.ReactNode
}

function isUUIDorEdit(path: string) {
  const uuidPattern =
    /.\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})\/?$/
  const editPattern =
    /.\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})\/edit\/?$/

  if (uuidPattern.test(path) || editPattern.test(path)) {
    return true
  } else {
    return false
  }
}

const Layout = ({ children, title, info, actions }: LayoutProps) => {
  const router = useRouter()
  const pathname = usePathname()

  return (
    <div className='w-full h-full flex flex-col'>
      <div className='flex flex-row items-center justify-between h-12 text-xl text-gray-900 border-b pb-3'>
        <div className='flex font-bold'>
          {window.history.length > 1 && isUUIDorEdit(pathname) && (
            <ArrowLeftOutlined onClick={() => router.back()} className='mr-3' />
          )}
          {title}
          <span className='self-end ml-8 text-base font-normal text-gray-500'>
            {info}
          </span>
        </div>
        {actions && <div className='flex items-center'>{actions}</div>}
      </div>
      <div className='mt-3 flex-1'>{children}</div>
    </div>
  )
}

export default Layout
